import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { addToast, handleAxiosError, useModals } from 'core/notifications';
import i18n from 'i18next';

import axios from '@/util/axios';

import SendAnnouncement from '../components/sendAnnouncement';

import useConfirmAction from '../hooks/useConfirmAction';
import useIsLegacyApp from '../hooks/useIsLegacyApp';

const SendAnnouncementContainer = ({
  confirmBody = '',
  getAxiosConfig = () => {},
  hasUrlTextInput = false,
  isConfirmationRequired = false,
  model: initialModel = {},
}) => {
  const isLegacyApp = useIsLegacyApp(); // TODO: remove
  const { removeModal } = useModals();
  const [formState, setFormState] = useState({});
  const [isEditing, setIsEditing] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [model, setModel] = useState(initialModel);

  const getConfirmation = useConfirmAction({
    body: confirmBody,
    title: i18n.t('confirm-bulk-action'),
  });

  const handleCancel = () => {
    if (isEditing) {
      removeModal();
    } else {
      setIsEditing(true);
    }
  };

  const handleLoad = (state) => {
    setFormState(state.formState);
  };

  const showToast = ({ data, status }) => {
    const { count, succeeded_count: successCount } = data;

    const button = {
      isExternalLink: isLegacyApp,
      text: i18n.t('review-details-in-system-log'),
      to: 'log_entries/list',
    };

    if (status === 202) {
      return addToast(
        { button, title: i18n.t('count-announcements-queued', { count }) },
        'success',
      );
    }

    if (!successCount) {
      return addToast(
        { button, title: i18n.t('error-creating-count-announcement', { count }) },
        'error',
      );
    }

    const errorCount = count - successCount;

    if (!errorCount) return addToast(i18n.t('count-announcement-created', { count }), 'success');

    addToast(
      { button, title: i18n.t('partial-announcement-error', { count, errorCount }) },
      'warning',
    );
  };

  const handleSubmit = async () => {
    if (isEditing) {
      return setIsEditing(false);
    }

    if (isConfirmationRequired && !(await getConfirmation())) return;

    setIsSubmitting(true);

    try {
      showToast(await axios(getAxiosConfig(model)));
    } catch (error) {
      setIsSubmitting(false);
      return handleAxiosError(error);
    }

    removeModal();
  };

  const handleUpdate = (state) => {
    setFormState(state.formState);
    setModel((prevModel) => ({ ...prevModel, ...state.update }));
  };

  return (
    <SendAnnouncement
      hasError={Object.values(formState).some(({ hasError }) => hasError)}
      hasUrlTextInput={hasUrlTextInput}
      isEditing={isEditing}
      isSubmitting={isSubmitting}
      model={model}
      onCancel={handleCancel}
      onLoad={handleLoad}
      onSubmit={handleSubmit}
      onUpdate={handleUpdate}
    />
  );
};

SendAnnouncementContainer.propTypes = {
  confirmBody: PropTypes.string,
  getAxiosConfig: PropTypes.func,
  hasUrlTextInput: PropTypes.bool,
  isConfirmationRequired: PropTypes.bool,
  model: PropTypes.shape({}),
};

export default SendAnnouncementContainer;
